import { Component, Input } from '@angular/core';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'short-answer-display',
  templateUrl: './short-answer-display.component.html',
  styleUrls: ['./short-answer-display.component.scss'],
})
export class ShortAnswerDisplayComponent {
  @Input() chartData: Array<any> = [];
  @Input() answers;

  public alternativeAnswers = [];
  public displayAnswers = [];
  public answerArray = [];
  public indexIdPairArray = [];
  public shortAnswers = [];

  constructor() {}

  currentSelction: number = null;

  selectAnswer(i) {
    this.currentSelction = this.currentSelction === i ? null : i;
  }

  ngOnInit() {
    let answers = cloneDeep(this.answers);
    this.setShortAnswers();
    this.answerArray = [];
    this.indexIdPairArray = [];
    this.resetDataDisplay(this.chartData);
  }

  ngOnChanges() {
    this.setShortAnswers();
    this.answerArray = [];
    this.indexIdPairArray = [];
    this.resetDataDisplay(this.chartData);
  }

  setShortAnswers() {
    this.shortAnswers = this.answers.fitbAnswer.blankAnswers.map((choice, idx) => {
      return {
        blankUID: choice.blankUID,
        userAnswer: '',
        choiceType: choice.choiceType,
        options: choice.options,
        indexOrder: idx,
      };
    });
  }

  resetDataDisplay(chartData) {
    chartData.forEach((answer) => {
      if (answer.id in this.indexIdPairArray) {
        let index = this.indexIdPairArray[answer.id];
        this.answerArray[index].push(answer);
      } else {
        let blankItem = this.shortAnswers.filter((option) => option.blankUID === answer.id);
        let index = blankItem[0].indexOrder;
        this.indexIdPairArray[answer.id] = index;
        this.answerArray[index] = [];
        this.answerArray[index].push(answer);
      }
    });
  }

  displaySet(word) {
    let count = typeof this.currentSelction === 'number' ? this.currentSelction + 1 : null;
    let data = this.currentSelction + 1 === word.id * 1 || !count;
    return data;
  }
}
